import React, { useState } from 'react';
import * as XLSX from 'xlsx';

// If you're using Material UI (MUI) components like Paper, Typography, Box, Input, Button:
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import Button from '@mui/material/Button';




function UploadTicketStatement({ onTransactionsExtracted }) {
    const [file, setFile] = useState(null);
  
    const handleFileChange = (e) => {
      setFile(e.target.files[0]);
    };
  
    const handleUpload = async () => {
      if (!file) {
        alert("Please select a file before uploading.");
        return;
      }
  
      try {
        // Read the file directly in the browser
        const data = await readExcelFile(file);
        onTransactionsExtracted(data);
        alert(`Found ${data.length} transactions in file`);
      } catch (error) {
        console.error("Error processing file:", error);
        alert("Failed to process file. Please try again.");
      }
    };
  
    // const readExcelFile = (file) => {
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader();
        
    //     reader.onload = (e) => {
    //       try {
    //         const data = new Uint8Array(e.target.result);
    //         const workbook = XLSX.read(data, { type: 'array' });
    //         const sheetName = workbook.SheetNames[0];
    //         const sheet = workbook.Sheets[sheetName];
    //         const jsonData = XLSX.utils.sheet_to_json(sheet);
            
    //         // Extract relevant data
    //         const transactions = jsonData.map(row => ({
    //           merchantId: row['Merchant Id']?.toString(),
    //           merchantOrderId: row['Merchant Order Id']?.toString(),
    //           amount: row['Total Transaction Amount'],
    //           date: row['Transaction Date'],
    //           status: row['Transaction Status'],
    //           // Add other fields as needed
    //         }));
            
    //         resolve(transactions);
    //       } catch (error) {
    //         reject(error);
    //       }
    //     };
        
    //     reader.onerror = (error) => reject(error);
    //     reader.readAsArrayBuffer(file);
    //   });
    // };


    const readExcelFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          
          reader.onload = (e) => {
            try {
              const data = new Uint8Array(e.target.result);
              const workbook = XLSX.read(data, { type: 'array' });
              const sheetName = workbook.SheetNames[0];
              const sheet = workbook.Sheets[sheetName];
              
              // Convert to JSON with header transformation
              const jsonData = XLSX.utils.sheet_to_json(sheet, {
                header: [
                  'Merchant Id', 'Transaction Type', 'Merchant Order Id', 
                  'Merchant Reference Id', 'PhonePe Reference Id',
                  'PhonePe Transaction Reference Id', 'PhonePe Attempt Reference Id',
                  'Transaction UTR', 'Total Transaction Amount', 'Transaction Date',
                  'Transaction Status', 'UPI Amount', 'Wallet Amount',
                  'Credit card Amount', 'Debit card Amount', 'External Wallet Amount',
                  'EGV Amount', 'Store Id', 'Terminal Id', 'Store Name',
                  'Terminal Name', 'Error Code', 'Detailed Error Code',
                  'Error Description', 'Error Source', 'Error Stage'
                ],
                range: 1 // Skip header row since we're providing our own headers
              });
              
              resolve(jsonData);
            } catch (error) {
              reject(error);
            }
          };
          
          reader.onerror = (error) => reject(error);
          reader.readAsArrayBuffer(file);
        });
      };
  
    return (
      <Paper elevation={1} sx={{ padding: 3 }}>
        <Typography variant="h6" gutterBottom>
          Upload Ticket Statement
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Input
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
            disableUnderline
            sx={{ width: '100%' }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpload}
            sx={{ alignSelf: 'flex-start' }}
          >
            Process File
          </Button>
        </Box>
      </Paper>
    );
  }


  export default UploadTicketStatement;